import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import CircularProgress from '@mui/material/CircularProgress';

import { useCourseContext } from '@ts-core/context/course';

import { useExercises } from 'modules/exercises/hooks';

import MultipleChoiceExerciseForm from '../../components/MultipleChoiceExerciseForm';

import { useMultipleChoiceExerciseActions, useMultipleChoiceExercise } from '../../hooks';
import { MultipleChoiceExerciseInput } from '../../types/form';
import { MultipleChoiceExercise } from '../../types';

const MultipleChoiceExercisePage = () => {
  const history = useHistory();
  const { course } = useCourseContext();

  const { courseId, subjectId, exerciseId } = useParams<{ courseId: string; subjectId: string; exerciseId?: string }>();
  const { onCreateMultipleChoiceExercise, createMultipleChoiceExerciseLoading, onUpdateMultipleChoiceExercise, updateMultipleChoiceExerciseLoading } =
    useMultipleChoiceExerciseActions({ courseId, subjectId });
  const { exercise, loading } = useMultipleChoiceExercise({ courseId, subjectId, exerciseId });
  const { exercises, loading: loadingExercises } = useExercises({ courseId, subjectId });

  const handleCreateMultipleChoiceExercise = useCallback(
    (input: MultipleChoiceExerciseInput) => {
      if (exerciseId) {
        onUpdateMultipleChoiceExercise(exerciseId, input);
      } else {
        onCreateMultipleChoiceExercise(input, (exercise: MultipleChoiceExercise) => {
          history.replace(`/${courseId}/subjects/${subjectId}/exercises/exercise/Default/${exercise.id}`);
        });
      }
    },
    [onCreateMultipleChoiceExercise, onUpdateMultipleChoiceExercise, history, exerciseId, courseId, subjectId]
  );

  if (loading || !course?._id || loadingExercises) {
    return <CircularProgress />;
  }

  const { config } = course;

  return (
    <MultipleChoiceExerciseForm
      submitting={createMultipleChoiceExerciseLoading || updateMultipleChoiceExerciseLoading}
      onSubmit={handleCreateMultipleChoiceExercise}
      exercise={exercise}
      defaultIncorrectOptionType={config.defaultIncorrectQuestionType}
      defaultNumberOfOptions={config.defaultNumberAnswers}
      exercisesCount={exercises?.length}
    />
  );
};

export default MultipleChoiceExercisePage;
